"use client"

import * as React from "react"
import { Search as LucideSearch, X as LucideX } from "lucide-react"
import { cn } from "../../lib/utils"

export interface SearchInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "value" | "onChange"> {
  value: string
  onChange: (value: string) => void
  onClear?: () => void
  containerClassName?: string
}

const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  (
    {
      value,
      onChange,
      onClear,
      placeholder = "Search...",
      className,
      containerClassName,
      type = "text",
      ...props
    },
    ref
  ) => {
    return (
      <div className={cn("relative flex items-center w-full", containerClassName)}>
        <div className="absolute left-3.5 flex items-center pointer-events-none text-gray-400">
          <LucideSearch className="h-4 w-4" />
        </div>
        <input
          ref={ref}
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className={cn(
            "w-full pl-10 pr-10 py-2.5 text-sm rounded-lg border border-black bg-white shadow-[0px_4px_0px_0px_#000000] focus:outline-none focus:ring-0 placeholder:text-gray-400 transition-all font-medium",
            className
          )}
          {...props}
        />
        {value && onClear && (
          <button
            type="button"
            onClick={onClear}
            className="absolute right-3.5 p-1 rounded-full text-gray-400 hover:text-black transition-colors cursor-pointer"
            aria-label="Clear search query"
          >
            <LucideX className="h-4 w-4" />
          </button>
        )}
      </div>
    )
  }
)

SearchInput.displayName = "SearchInput"

export { SearchInput }
